import apiClient from '../client'
import type { ReleaseHistoryResponse } from './types'

export const releaseHistoriesApi = {
  list() {
    return apiClient.get<ReleaseHistoryResponse[]>('/api/release-histories')
  },
}
